import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { CategoryResponse } from "../models/response";
import { ICategoryApi } from "./base/categoryApi";

const baseRoute: string = "PartCategory";

export class CategoryApi extends ICategoryApi {
	getDomain(isCanastaBasica: boolean): Promise<AxiosResponse<Result<CategoryResponse[]>>> {
		return api.get(`${baseRoute}/domain`, { params: { isCanastaBasica } });
	}
}
